export default function CheckBoxChecked() {
  return (
    <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="checkbox">
        <path
          id="Subtract"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M16.9441 1.75098H5C2.23858 1.75098 0 3.98955 0 6.75098V18.751C0 21.5124 2.23858 23.751 5 23.751H17C19.7614 23.751 22 21.5124 22 18.751V6.75098C22 6.7056 21.9994 6.66036 21.9982 6.61527C21.2521 7.66326 20.5897 8.70416 20 9.70779V18.751C20 20.4078 18.6569 21.751 17 21.751H5C3.34315 21.751 2 20.4078 2 18.751V6.75098C2 5.09412 3.34315 3.75098 5 3.75098H14.7878C15.4426 3.0807 16.1614 2.40562 16.9441 1.75098Z"
          fill="white"
        />
        <path
          id="Vector 23"
          d="M10.2284 18.249C10.2284 18.249 6.00899 10.4029 5 9.66441C5.82554 8.83364 7.86875 8.02872 8.85252 8.55672C9.83629 9.08472 11.6937 12.0911 11.6937 12.0911C11.6937 12.0911 15.354 4.83862 22.2994 1.11009C22.6853 0.902922 23.0231 1.38323 22.7296 1.70833C16.771 8.30825 14.555 15.6951 13.5306 16.726C12.4299 17.8336 10.2284 18.249 10.2284 18.249Z"
          fill="white"
        />
      </g>
    </svg>
  );
}
